import Styles from './AivagamButton.module.scss';
import { Tooltip } from '@mui/material/';

/**
 * JSX button element with predefined responsive behaviour and styles adhering to AIVAGAM theme
 * @param {string} id 
 * @param {Function} onClick 
 * @param {boolean} disabled 
 * @param {string} buttonText 
 * @param {boolean} icon applies icons styling if true, default false
 * @param {string} type null (blue, default) | confirm (green) | cancel | action (yellow) | edit (grey) | destruct (red) | back
 * @param {object} classStyles any styles to override existing styles 
 * @param {string} tooltipText text to show on the tooltip
 * @param {string} tooltipPos position of the tool tip, default 'bottom'  'bottom-end', 'bottom-start', 'bottom', 'left-end', 'left-start', 'left', 'right-end', 'right-start', 'right', 'top-end', 'top-start', 'top'
 * @param {string} buttonType `type` attribute of standard html class: text, submit, reset etc
 * @param {object} props 
 * 
 * @returns JSX returns an html button with AIVAGAM themes
 */
export function AivagamButton({
    id,
    onClick,
    disabled,
    classStyles,
    buttonText,
    type,
    icon = false,
    props,
    buttonType,
    tooltipText,
    tooltipPos,
}) {
    let buttonClassName = Styles.aivagamButton;
    if (type === 'confirm') {
        buttonClassName += ` ${Styles.confirmStyle}`;
    } else if (type === 'cancel') {
        buttonClassName += ` ${Styles.cancelStyle}`;
    } else if (type === 'action') {
        buttonClassName += ` ${Styles.actionStyle}`;
    } else if (type === 'edit') {
        buttonClassName += ` ${Styles.editorStyle}`;
    } else if (type === 'destruct') {
        buttonClassName += ` ${Styles.destructStyle}`;
    } else if (type === 'back') {
        buttonClassName += ` ${Styles.backStyle}`;
    }

    if (icon) {
        buttonClassName += ` ${Styles.iconStyles}`;
    }

    // Process classStyles prop if it's an object
    let inlineStyles = {};
    if (classStyles && typeof classStyles === 'object') {
        inlineStyles = classStyles;
    }

    return (
        tooltipText ? (
            <Tooltip title={tooltipText} arrow placement={tooltipPos ?? "bottom"}>
                <span>
                    <button
                        id={id ? id : ""}
                        className={buttonClassName}
                        onClick={onClick}
                        disabled={disabled}
                        style={inlineStyles}
                        type={buttonType}
                        {...props}
                    >
                        {buttonText}
                    </button>
                </span>
            </Tooltip>
        ) : (
            <button
                id={id ? id : ""}
                className={buttonClassName}
                onClick={onClick}
                disabled={disabled}
                style={inlineStyles}
                type={buttonType}
                {...props}
            >
                {buttonText}
            </button>
        )
    );
}